<template>
  <div class="card-item">
    <img :src="item.img || '/static/images/d.png '" alt="">
    <p class="name">{{item.name}}</p>
    <p class="info">
      <span>当前{{item.number}}期</span>
      <span>距离开奖：<i>{{minutes || '00'}} : {{seconds || '00'}}</i></span>
    </p>
  </div>
</template>

<script>
  export default {
    name: "card-item",
    props: {
      item: {
        type: Object,
        default () {
          return {
            img: '',
            name: '',
            number: '',
            target: ''
          }
        }
      }
    },
    data () {
      return {
        seconds: '',
        minutes: ''
      }
    },
    methods: {
      format (target, serveTime) {
        let t_stamp = typeof target === "string" ? Date.parse(target.replace(/-/g, '/')) : target;
        let now = serveTime || Date.now();
        now = typeof now === "string" ? Date.parse(now) : now;
        const diff = t_stamp - now;
        return {
          minutes: Math.floor(diff / 1000 / 60 % 60),
          seconds: Math.floor(diff / 1000 % 60)
        }
      },
      countdown (callback) {
        clearInterval(this.timer);
        this.timer = setInterval(() => {
          let {minutes, seconds} = this.format(this.item.target);
          minutes = minutes < 0 ? 0 : minutes;
          seconds = seconds < 0 ? 0 : seconds;
          this.minutes = minutes < 10 ? '0' + minutes : minutes;
          this.seconds = seconds < 10 ? '0' + seconds : seconds;
          if (minutes <= 0 && seconds <= 0) {
            callback && callback();
            clearInterval(this.timer);
          }
        }, 1000);
      }
    },
    mounted() {
      this.countdown();
    },
    beforeDestroy() {
      clearInterval(this.timer);
    }
  }
</script>

<style scoped lang="less">
  .card-item{
    color: #464646;
    display: flex;
    padding: 30px 60px 30px 30px;
    font-size: 32px;
    background: #fff;
    box-sizing: border-box;
    align-items: center;
    border-radius: 6px;
    >img{
      width: 100px;
      height: 100px;
      border-radius: 50px;
      background-color: orangered;
    }
    >.name{
      flex: 1;
      margin-top: 10px;
      align-self: flex-start;
      flex-shrink: 0;
      margin-left: 50px;
    }
    >.info{
      flex: 1;
      color: #999;
      height: 86px;
      display: flex;
      font-size: 24px;
      flex-direction: column;
      justify-content: space-between;
      >span{
        flex: 1;
        line-height: 36px;
        >i{
          color: #008000;
          font-weight: bold;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/home/rule/card-item/index.vue